import { render, staticRenderFns } from "./bookMangmentImage.vue?vue&type=template&id=67a52cd4&"
import script from "./bookMangmentImage.vue?vue&type=script&lang=js&"
export * from "./bookMangmentImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports